"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsContainer = exports.Option = exports.Dropdown = exports.Wrapper = void 0;
const native_1 = __importStar(require("styled-components/native"));
exports.Wrapper = native_1.default.View `
  margin: 20px 20px 150px;
`;
exports.Dropdown = native_1.default.TouchableOpacity `
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: ${({ theme }) => `${theme.bpCore.gridSize * 6}px`};
  padding:${({ theme }) => `${theme.bpCore.gridSize * 1.5}px ${theme.bpCore.gridSize}px ${theme.bpCore.gridSize * 1.5}px ${theme.bpCore.gridSize * 2}px`};
  color: ${({ theme }) => theme.bpCore.textInput.default.color};
  background-color: ${({ theme }) => theme.bpCore.textInput.default.backgroundColor};
  border: 1px solid ${({ theme }) => theme.bpCore.textInput.default.borderColor};

    ${({ active, success, error, theme }) => active &&
    !success &&
    !error &&
    native_1.css `
        border-color: ${theme.bpCore.colors.primary[500]};
      `}
    ${({ success, theme }) => success &&
    native_1.css `
      color: ${theme.bpCore.textInput.success.color};
      background-color: ${theme.bpCore.textInput.success.backgroundColor}
      border-color: ${theme.bpCore.textInput.success.borderColor};
    `}
    ${({ error, theme }) => error &&
    native_1.css `
        color: ${theme.bpCore.textInput.error.color};
        background-color: ${theme.bpCore.textInput.error.backgroundColor};
        border-color: ${theme.bpCore.textInput.error.borderColor};
      `}
    ${({ disabled, theme }) => disabled &&
    native_1.css `
        color: ${theme.bpCore.textInput.disabled.color};
        background-color: ${theme.bpCore.textInput.disabled.backgroundColor};
        border-color: ${theme.bpCore.textInput.disabled.borderColor};
      `};
`;
exports.Option = native_1.default.TouchableOpacity `
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-horizontal: ${({ theme }) => `${theme.bpCore.gridSize * 2}px`};
  height: 46px;
`;
exports.OptionsContainer = native_1.default.ScrollView `
  width: 100%;
  background-color: white;
  shadow-offset: {
    height: 30;
  }
  shadow-radius: 25px;
  elevation: 5;
  shadow-opacity: 0.2;
  z-index: 50;
  max-height: ${({ theme }) => `${theme.bpCore.gridSize * 6 * 6}px`};
  padding-vertical: ${({ theme }) => `${theme.bpCore.gridSize}px`};
  background: ${({ theme }) => theme.bpCore.colors.white};
  ${({ dropDownPositionAtBottom }) => {
    if (dropDownPositionAtBottom)
        return '';
    return native_1.css `
      position: absolute;
      top: 80px;
    `;
}}
`;
